/**
 * ZIP-code popup and region-based link rewriting.
 * 2026-10-11: ZIP tables + local names moved to zip-city-data.js (loaded on demand);
 * duplicate-card pass caches its container lookups; no double pass at init.
 * When user selects ZIP (LA / SF / Honolulu): rewrite all collection and product links
 * to point to the duplicated versions (-la, -sf, -hnl). Nothing is hidden — links are replaced.
 * Cookie: store_city = los_angeles | honolulu | san_francisco | other
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'store_city';
  var COOKIE_DAYS = 365;
  var BODY_ATTR = 'data-store-city';
  var ORIGINAL_HREF = 'data-original-href';
  var REWRITTEN_ATTR = 'data-region-rewritten';
  var DATA_REGION = 'data-region';

  /* PCREGION FALLBACK 2026-06-27: whitelist of regional collection handles that actually resolve
     (real collections + URL redirects). rewriteLink consults this so a /collections/ link is only
     region-rewritten when the target exists; otherwise the working base link is kept (no 404). */
  var PC_TWIN_COLL = {"sf":{"funeral-flowers-delivery-sf":1,"100-250-sf":1,"200-sf":1,"250-350-sf":1,"350-sf":1,"all-flowers-sf":1,"anniversary-flowers-delivery-sf":1,"apology-flowers-sf":1,"arrangement-sf":1,"baskets-sf":1,"best-sellers-sf":1,"birthday-flowers-delivery-sf":1,"black-flowers-delivery-los-angeles-sf":1,"blue-sf":1,"bridal-bouquet-sf":1,"cart-upsell-sf":1,"christmas-sf":1,"corporate-flower-arrangements-gifts-sf":1,"designer-floral-arrangements-los-angeles-sf":1,"exclusive-collection-sf":1,"exclusive-sf":1,"exotic-tropical-flowers-delivery-los-angeles-sf":1,"fall-florals-collection-sf":1,"father-s-day-sf":1,"floral-therapy-collection-sf":1,"flowers-bouquet-sf":1,"flowers-box-delivery-sf":1,"flowers-on-sale-sf":1,"flowers-safe-for-cats-sf":1,"flowers-safe-for-dogs-sf":1,"flowers-under-99-sf":1,"for-him-sf":1,"fourth-of-july-flowers-sf":1,"french-vibes-sf":1,"frontpage-sf":1,"funeral-sf":1,"get-well-sf":1,"gifts-delivery-sf":1,"green-flowers-delivery-los-angeles-sf":1,"hanukkah-sf":1,"heart-collection-sf":1,"hydrangea-delivery-in-sf":1,"just-because-flowers-sf":1,"lilies-delivery-sf":1,"love-romance-sf":1,"luxury-flower-arrangements-sf":1,"luxury-flower-gifts-los-angeles-sf":1,"main-collection-sf":1,"mixed-flowers-sf":1,"mothers-day-flowers-delivery-sf":1,"new-baby-sf":1,"new-sf":1,"orchids-sf":1,"peach-orange-flowers-delivery-los-angeles-sf":1,"peonies-delivery-sf":1,"pink-sf":1,"plants-delivery-sf":1,"pride-month-flowers-los-angeles-sf":1,"proposal-pathway-decor-sf":1,"purple-flowers-delivery-los-angeles-sf":1,"red-flowers-delivery-sf":1,"roses-delivery-sf":1,"same-day-flower-delivery-sf":1,"seasonal-flowers-sf":1,"shabbat-sf":1,"spring-sale-sf":1,"subscribe-save-sf":1,"sunflowers-delivery-sf":1,"top-rated-sf":1,"tulips-delivery-sf":1,"valentine-s-day-1-sf":1,"wedding-sf":1,"white-flowers-delivery-sf":1,"yellow-sf":1},"hnl":{"funeral-flowers-delivery-hnl":1,"100-250-hnl":1,"200-hnl":1,"250-350-hnl":1,"350-hnl":1,"all-flowers-hnl":1,"anniversary-flowers-delivery-hnl":1,"apology-flowers-hnl":1,"arrangement-hnl":1,"baskets-hnl":1,"best-sellers-hnl":1,"birthday-flowers-delivery-hnl":1,"black-flowers-delivery-los-angeles-hnl":1,"blue-hnl":1,"bridal-bouquet-hnl":1,"cart-upsell-hnl":1,"christmas-hnl":1,"corporate-flower-arrangements-gifts-hnl":1,"designer-floral-arrangements-los-angeles-hnl":1,"exclusive-collection-hnl":1,"exclusive-hnl":1,"exotic-tropical-flowers-delivery-los-angeles-hnl":1,"fall-florals-collection-hnl":1,"father-s-day-hnl":1,"floral-therapy-collection-hnl":1,"flowers-bouquet-hnl":1,"flowers-box-delivery-hnl":1,"flowers-on-sale-hnl":1,"flowers-safe-for-cats-hnl":1,"flowers-safe-for-dogs-hnl":1,"flowers-under-99-hnl":1,"for-him-hnl":1,"fourth-of-july-flowers-hnl":1,"french-vibes-hnl":1,"frontpage-hnl":1,"funeral-hnl":1,"get-well-hnl":1,"gifts-delivery-hnl":1,"green-flowers-delivery-los-angeles-hnl":1,"hanukkah-hnl":1,"heart-collection-hnl":1,"hydrangea-delivery-in-hnl":1,"just-because-flowers-hnl":1,"lilies-delivery-hnl":1,"love-romance-hnl":1,"luxury-flower-arrangements-hnl":1,"luxury-flower-gifts-los-angeles-hnl":1,"main-collection-hnl":1,"mixed-flowers-hnl":1,"mothers-day-flowers-delivery-hnl":1,"new-baby-hnl":1,"new-hnl":1,"orchids-hnl":1,"peach-orange-flowers-delivery-los-angeles-hnl":1,"peonies-delivery-hnl":1,"pink-hnl":1,"plants-delivery-hnl":1,"pride-month-flowers-los-angeles-hnl":1,"proposal-pathway-decor-hnl":1,"purple-flowers-delivery-los-angeles-hnl":1,"red-flowers-delivery-hnl":1,"roses-delivery-hnl":1,"same-day-flower-delivery-hnl":1,"seasonal-flowers-hnl":1,"shabbat-hnl":1,"spring-sale-hnl":1,"subscribe-save-hnl":1,"sunflowers-delivery-hnl":1,"top-rated-hnl":1,"tulips-delivery-hnl":1,"valentine-s-day-1-hnl":1,"wedding-hnl":1,"white-flowers-delivery-hnl":1,"yellow-hnl":1}};

  /* ZIP tables + local names live in zip-city-data.js (2026-10-11): loaded on demand so the
     ~40 KB of lookup data is not parsed on every page view. The URL comes from the snippet
     (data-zip-data attribute on this script tag). */
  var DATA_URL = (document.currentScript && document.currentScript.getAttribute('data-zip-data')) || '';
  var dataLoading = false, dataCbs = [];
  function zipData() { return window.PC_ZIP_DATA || null; }
  function ensureData(cb) {
    if (zipData()) { if (cb) cb(); return; }
    if (cb) dataCbs.push(cb);
    if (dataLoading || !DATA_URL) return;
    dataLoading = true;
    window.__pcZipDataReady = function () {
      var list = dataCbs; dataCbs = [];
      for (var i = 0; i < list.length; i++) { try { list[i](); } catch (e) {} }
    };
    var s = document.createElement('script');
    s.src = DATA_URL; s.async = true;
    s.onerror = function () { dataLoading = false; };
    document.head.appendChild(s);
  }
  function zipList(name) { var d = zipData(); return (d && d[name]) || []; }

  /** Region by ZIP. Returns null while the data file is not loaded yet (and triggers the load). */
  function getCityByZip(zip) {
    var z = String(zip).replace(/\D/g, '').slice(0, 5);
    if (z.length < 5) return null;
    if (!zipData()) { ensureData(); return null; }
    if (zipList('LA_ZIPS').indexOf(z) >= 0) return 'los_angeles';
    if (zipList('HONOLULU_ZIPS').indexOf(z) >= 0) return 'honolulu';
    if (zipList('SF_ZIPS').indexOf(z) >= 0) return 'san_francisco';
    if (zipList('VENTURA_ZIPS').indexOf(z) >= 0) return 'ventura';
    if (zipList('OC_ZIPS').indexOf(z) >= 0) return 'orange_county';
    if (zipList('IE_ZIPS').indexOf(z) >= 0) return 'inland_empire';
    return 'other';
  }

  /** Cookie/cart may have full (los_angeles) or short (la) — always return la|sf|hnl or null */
  function cityToRegion(city) {
    var c = (city || '').toLowerCase().trim();
    if (c === 'los_angeles' || c === 'la') return 'la';
    if (c === 'san_francisco' || c === 'sf') return 'sf';
    if (c === 'honolulu' || c === 'hnl') return 'hnl';
    if (c === 'ventura' || c === 'vc') return 'la'; // VC shares the LA catalog since 2026-07-05 (clones drafted)
    if (c === 'orange_county' || c === 'oc') return 'la'; // OC shares the LA catalog (no -oc clones)
    if (c === 'inland_empire' || c === 'ie') return 'la'; // IE shares the LA catalog (no clones)
    return null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;expires=' + d.toUTCString() + ';SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  /** Map URL slug (query value, param name, path segment, hash) → canonical store city id */
  function slugToCity(slug) {
    var c = String(slug || '').toLowerCase().trim();
    if (!c) return null;
    if (c === 'honolulu' || c === 'hnl') return 'honolulu';
    if (c === 'san_francisco' || c === 'sf' || c === 'san-francisco' || c === 'sanfrancisco') return 'san_francisco';
    if (c === 'los_angeles' || c === 'la' || c === 'los-angeles' || c === 'losangeles') return 'los_angeles';
    if (c === 'ventura' || c === 'vc' || c === 'ventura-county' || c === 'ventura_county') return 'ventura';
    if (c === 'orange_county' || c === 'oc' || c === 'orange-county' || c === 'orangecounty') return 'orange_county';
    if (c === 'inland_empire' || c === 'ie' || c === 'inland-empire' || c === 'inlandempire') return 'inland_empire';
    return null;
  }

  /** Canonical home URL. 2026-09-16: always the clean "/" — the region lives in the
      store_city cookie + cart attributes, so we no longer expose "/?city=…" variants
      (they were getting indexed as duplicate homepages). "?city=" in incoming links is
      still parsed by getCityFromUrl() for backward compatibility. */
  function homeUrlWithCityQuery(city) {
    return '/';
  }

  /**
   * Parse city from URL (in order):
   * - ?city= (канон, как раньше)
   * - Hash #honolulu (старые ссылки / return_to)
   * - Pretty query: город как имя параметра
   * - Path: /honolulu
   */
  function getCityFromUrl() {
    var params = typeof URLSearchParams !== 'undefined' && window.location.search ? new URLSearchParams(window.location.search) : null;
    if (params && params.has('city')) {
      var fromCityParam = slugToCity(params.get('city'));
      if (fromCityParam) return fromCityParam;
    }
    var hash = (window.location.hash || '').replace(/^#/, '').split(/[?&]/)[0];
    if (hash) {
      var fromHash = slugToCity(decodeURIComponent(hash));
      if (fromHash) return fromHash;
    }
    if (params) {
      var keys = [];
      params.forEach(function (_v, k) {
        keys.push(k);
      });
      var i;
      for (i = 0; i < keys.length; i++) {
        var fromKey = slugToCity(keys[i]);
        if (fromKey) return fromKey;
      }
    }
    var path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    if (path !== '/' && path.indexOf('/') === 0) {
      var segments = path.slice(1).split('/').filter(Boolean);
      if (segments.length === 1) {
        var fromPath = slugToCity(segments[0]);
        if (fromPath) return fromPath;
      }
    }
    return null;
  }

  /** City for rewriting: cookie, then URL (?city= / hash / path / pretty), then cart, then body */
  function getCityForRewrite() {
    var city = getCookie(COOKIE_NAME);
    if (city) return city;
    city = getCityFromUrl();
    if (city) return city;
    var fromCart = typeof window.__STORE_CITY_FROM_CART__ !== 'undefined' && window.__STORE_CITY_FROM_CART__;
    if (fromCart && String(fromCart).trim()) return String(fromCart).trim();
    var bodyCity = document.body.getAttribute(BODY_ATTR);
    if (bodyCity && /^(la|sf|hnl|vc|oc|ie|los_angeles|san_francisco|honolulu|ventura|orange_county|inland_empire)$/i.test(bodyCity)) return bodyCity;
    return null;
  }

  function isHomePath() {
    var path = (window.location.pathname || '/').replace(/\/$/, '') || '/';
    if (path === '' || path === '/' || path === '/index' || path === '/pages/index') return true;
    if (path.indexOf('/') === 0 && path.length > 1) {
      var segments = path.slice(1).split('/').filter(Boolean);
      if (segments.length === 1 && slugToCity(segments[0])) return true;
    }
    return false;
  }

  function getCityDisplayName(city) {
    if (!city) return 'Change Location';
    var c = String(city).toLowerCase();
    if (c === 'los_angeles' || c === 'la') return 'Los Angeles County';
    if (c === 'san_francisco' || c === 'sf') return 'San Francisco Bay Area';
    if (c === 'honolulu' || c === 'hnl') return 'Honolulu (Oahu)';
    if (c === 'ventura' || c === 'vc') return 'Ventura County';
    if (c === 'orange_county' || c === 'oc') return 'Orange County';
    if (c === 'inland_empire' || c === 'ie') return 'Inland Empire';
    return 'Change Location';
  }


  /* ---- Smart search: city names + addresses (2026-07-05) ---- */
  var CITY_INDEX = null;
  function normName(s) {
    return String(s || '').toLowerCase().replace(/[\u00e0-\u00e5]/g, 'a').replace(/\u00e7/g, 'c').replace(/[\u00e8-\u00eb]/g, 'e').replace(/[\u00f1]/g, 'n').replace(/\s+/g, ' ').trim();
  }
  function buildCityIndex() {
    if (CITY_INDEX) return CITY_INDEX;
    var d = zipData();
    if (!d) { ensureData(); return {}; } // not cached: rebuilt once the data arrives
    CITY_INDEX = {};
    var ZIP_LOCAL_NAMES = d.ZIP_LOCAL_NAMES, SF_CITY_NAMES = d.SF_CITY_NAMES;
    for (var z in ZIP_LOCAL_NAMES) {
      var name = ZIP_LOCAL_NAMES[z];
      var region = getCityByZip(z);
      if (!region || region === 'other') continue;
      if (!CITY_INDEX[name]) CITY_INDEX[name] = { region: region, zip: z, n: normName(name) };
    }
    for (var i = 0; i < SF_CITY_NAMES.length; i++) {
      var nm = SF_CITY_NAMES[i];
      if (!CITY_INDEX[nm]) CITY_INDEX[nm] = { region: 'san_francisco', zip: null, n: normName(nm) };
    }
    var extras = { 'Los Angeles': ['los_angeles', '90012'], 'Orange County': ['orange_county', '92618'], 'Inland Empire': ['inland_empire', '91764'], 'Oahu': ['honolulu', '96813'] };
    for (var e in extras) {
      if (!CITY_INDEX[e]) CITY_INDEX[e] = { region: extras[e][0], zip: extras[e][1], n: normName(e) };
    }
    return CITY_INDEX;
  }
  /** typing mode: prefix matches first, then substring; resolve mode: city name contained in query (addresses) */
  function findCityMatches(query, resolveMode) {
    var idx = buildCityIndex();
    var q = normName(query);
    if (q.length < 2) return [];
    var starts = [], contains = [];
    for (var name in idx) {
      var e = idx[name];
      if (resolveMode) {
        if (q === e.n || q.indexOf(e.n) >= 0) contains.push({ name: name, region: e.region, zip: e.zip, len: e.n.length });
        else if (e.n.indexOf(q) === 0) starts.push({ name: name, region: e.region, zip: e.zip, len: e.n.length });
      } else {
        if (e.n.indexOf(q) === 0) starts.push({ name: name, region: e.region, zip: e.zip, len: e.n.length });
        else if (e.n.indexOf(q) >= 0) contains.push({ name: name, region: e.region, zip: e.zip, len: e.n.length });
      }
    }
    if (resolveMode) {
      contains.sort(function (a, b) { return b.len - a.len; });
      return contains.length ? contains : starts;
    }
    starts.sort(function (a, b) { return a.name.length - b.name.length; });
    contains.sort(function (a, b) { return a.name.length - b.name.length; });
    return starts.concat(contains).slice(0, 6);
  }
  /** ZIP anywhere in string, else city name (longest wins). Returns {city, zip} or {error} */
  function smartResolve(qRaw) {
    var q = String(qRaw || '').trim();
    if (!q) return { error: 'Please enter your ZIP code, city or address.' };
    var zm = q.match(/\b(\d{5})\b/);
    if (zm) {
      var c = getCityByZip(zm[1]);
      if (c && c !== 'other') return { city: c, zip: zm[1] };
    }
    var matches = findCityMatches(q, true);
    if (matches.length) return { city: matches[0].region, zip: matches[0].zip };
    if (zm) return { error: "Sorry, we don't deliver to " + zm[1] + ' yet.' };
    return { error: "We couldn't find that city \u2014 try entering your ZIP code." };
  }

  function updateTriggerLabel(city) {
    var label = getCityDisplayName(city);
    var trigger = document.getElementById('zip-popup-trigger');
    if (trigger) {
      var textEl = trigger.querySelector('.zip-popup-trigger-text');
      if (textEl) textEl.textContent = label;
      trigger.setAttribute('aria-label', label);
      trigger.setAttribute('title', label);
    }
    document.querySelectorAll('.gh-actions__location-btn[data-open-zip-popup]').forEach(function (el) {
      el.setAttribute('aria-label', label);
      el.setAttribute('title', label);
    });
  }

  /** Strip -la, -sf, -hnl or trailing hyphen from handle to get base handle (theme may output "harmony-") */
  function getHandleBase(handle) {
    if (!handle || typeof handle !== 'string') return '';
    var base = handle.replace(/-la$|-sf$|-hnl$|-vc$/i, '').trim();
    base = base.replace(/-+$/, ''); // trim trailing hyphen(s) so "harmony-" -> "harmony"
    return base;
  }

  /** Get region from handle for filtering: la, sf, hnl, or base */
  function getRegionFromHandle(handle) {
    if (!handle || typeof handle !== 'string') return 'base';
    var h = handle.toLowerCase().replace(/-+$/, '').trim();
    if (h.length >= 3 && h.slice(-3) === '-la') return 'la';
    if (h.length >= 3 && h.slice(-3) === '-sf') return 'sf';
    if (h.length >= 4 && h.slice(-4) === '-hnl') return 'hnl';
    if (h.length >= 3 && h.slice(-3) === '-vc') return 'vc';
    return 'base';
  }

  function getHandleFromHref(href) {
    if (!href) return '';
    var m = href.match(/\/(?:collections|products)\/([^/?]+)/);
    return m ? m[1] : '';
  }

  /** LA uses base handles (no -la); treat base as matching when filter is la. SF/HNL use -sf/-hnl only. */
  function regionMatchesFilter(region, cardRegion) {
    if (!region) return true;
    if (cardRegion === region) return true;
    if (region === 'la' && cardRegion === 'base') return true;
    return false;
  }

  /** Search UI + product page recommendations («BUY WITH») — same duplicate filter as predictive search. */
  var ctxCache = null; // per-pass cache of the search containers + <main> (2026-10-11: was re-queried for every element)
  function ctxPrepare() {
    ctxCache = {
      containers: document.querySelectorAll('.predictive-search, .search-modal, [class*="predictive"], [class*="search-modal"], #Search-In-Modal'),
      main: document.querySelector('main')
    };
  }
  function ctxDone() { ctxCache = null; }
  function inRegionDuplicateFilterContext(el) {
    var ctx = ctxCache || {
      containers: document.querySelectorAll('.predictive-search, .search-modal, [class*="predictive"], [class*="search-modal"], #Search-In-Modal'),
      main: document.querySelector('main')
    };
    var searchContainers = ctx.containers;
    var i;
    for (i = 0; i < searchContainers.length; i++) {
      if (searchContainers[i].contains(el)) return true;
    }
    var mainEl = ctx.main;
    var isSearchPage = window.location.pathname === '/search' || (mainEl && mainEl.classList && mainEl.classList.contains('search'));
    if (isSearchPage && mainEl && mainEl.contains(el)) return true;
    if (window.location.pathname.indexOf('/collections/') === 0 && mainEl && mainEl.contains(el)) {
      // NEVER dedup the main collection product grid — a collection page must show exactly its
      // curated products to every visitor (any region). Dedup here was emptying base + regional
      // grids for non-LA visitors. Other blocks on the page (search/recs) still dedup.
      if (el.closest && el.closest('#product-grid, #ProductGridContainer')) return false;
      return true;
    }
    if (el.closest && el.closest('#product-grid, [id^="product-grid"], [class*="collection-list"], .collection')) return true;
    if (el.closest && el.closest('[class*="featured-collection"]')) {
      var __isHome = (window.location.pathname === '/' || window.location.pathname === '');
      return !__isHome; // homepage featured-collection (base-only bestsellers) must NOT be region-hidden
    }
    // recommendations / related / complementary sections are NOT region-deduped — keep recommended cards visible (fixes orphan "BUY WITH")
    return false;
  }

  /** Mark product/collection links and card parents with data-region so we can hide duplicates in search.
   * Use original href (before rewrite) when present, so each card keeps its real region (la/sf/hnl/base). */
  function markRegionOnLinks() {
    var links = document.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]');
    var cardSel = '[class*="card"], [class*="product"], [class*="search"], [class*="predictive"], .grid__item, .list-view-item, li';
    links.forEach(function (link) {
      if (link.closest('#zip-code-popup')) return;
      var href = link.getAttribute(ORIGINAL_HREF) || link.getAttribute('href') || '';
      var handle = getHandleFromHref(href);
      var r = getRegionFromHandle(handle);
      var base = getHandleBase(handle);
      link.setAttribute(DATA_REGION, r);
      link.setAttribute('data-region-base', base);
      var parent = link.closest(cardSel);
      if (parent && parent !== link) { parent.setAttribute(DATA_REGION, r); parent.setAttribute('data-region-base', base); }
      var li = link.closest('li');
      if (li) { li.setAttribute(DATA_REGION, r); li.setAttribute('data-region-base', base); }
    });
  }

  /** In search + recommendations: hide cards that are not for the selected region */
  function isRegionalCollectionPage() {
    return /\/collections\/[^\/]*-(?:vc|hnl|sf)(?:\/|$)/.test(window.location.pathname);
  }
  function hideDuplicateCards(region) {
    markRegionOnLinks();
    region = region || 'la';
    if (isRegionalCollectionPage()) return; // products already correct region -> never hide the grid
    ctxPrepare();
    var regionClones = {};
    if (region !== 'la') {
      document.querySelectorAll('[' + DATA_REGION + ']').forEach(function (el) {
        if (!inRegionDuplicateFilterContext(el)) return;
        if (el.getAttribute(DATA_REGION) === region) {
          var b = el.getAttribute('data-region-base');
          if (b) regionClones[b] = true;
        }
      });
    }
    document.querySelectorAll('[' + DATA_REGION + ']').forEach(function (el) {
      if (!inRegionDuplicateFilterContext(el)) return;
      var r = el.getAttribute(DATA_REGION);
      var show;
      if (region === 'la') {
        show = (r === 'la' || r === 'base');
      } else if (r === region) {
        show = true;
      } else if (r === 'base' || r === 'la') {
        var b = el.getAttribute('data-region-base');
        show = !(b && regionClones[b]);
      } else {
        show = false;
      }
      el.style.display = show ? '' : 'none';
    });
    ctxDone();
  }

  function showAllSearchCards() {
    markRegionOnLinks();
    ctxPrepare();
    document.querySelectorAll('[' + DATA_REGION + ']').forEach(function (el) {
      if (inRegionDuplicateFilterContext(el)) el.style.display = '';
    });
    ctxDone();
  }

  /** Rewrite one link to point to region version.
   * Rules:
   * - LA: use base handle (no suffix) because base products already exist
   * - SF/HNL: use duplicated handles (-sf / -hnl)
   */
  var PC_TWIN_PROD = {"sf":{"valentine-s-heart-box-sf":1,"100-roses-pink-clover-sf":1,"balloons-sf":1,"champagne-sf":1,"sparkling-wine-sf":1,"75-red-roses-bouquet-sf":1,"white-roses-and-hydrangea-flowers-bridal-bouquet-adele-sf":1,"alexandra-arrangement-of-garden-roses-hydrangea-stachys-and-carnations-in-round-box-sf":1,"lilies-and-purple-roses-in-pink-box-sf":1,"gorgeous-arrangement-of-dahlias-lilies-roses-amelita-sf":1,"multicolor-bouquet-of-roses-with-carnations-flowers-aminah-sf":1,"purple-and-pink-roses-with-carnations-flowers-arrangement-anastasia-sf":1,"spring-bouquet-chamomile-and-peach-garden-roses-sf":1,"arrangement-of-peonies-variety-of-roses-antonia-sf":1,"orchids-with-lilies-and-roses-arleta-sf":1,"gold-box-with-white-and-yellow-roses-sf":1,"boxes-i-love-you-3-boxes-sf":1,"box-with-anemones-rosesand-sf":1,"boutonniere-sf":1,"bright-box-sf":1,"burgundy-box-sf":1,"candy-box-sf":1,"white-arrangement-with-orchids-catherine-sf":1,"white-orchids-with-hydrangea-and-roses-flowers-in-round-box-chantelle-sf":1,"50-red-roses-in-velvet-box-sf":1,"chocolate-sweets-sf":1,"orchids-flowers-with-mums-and-roses-in-round-box-christa-sf":1,"bride-bouquet-1-sf":1,"cora-sf":1,"corsage-sf":1,"orchids-and-hydrangeas-chrysanthemums-flowers-round-box-dale-sf":1,"diana-sf":1,"dolly-roses-with-greenery-sf":1,"dora-arrangement-of-blue-hydrangea-stachys-and-roses-in-box-sf":1,"lovely-box-sf":1,"arrangement-with-anemones-sf":1,"white-roses-dahlia-and-irises-enola-sf":1,"eternal-love-sf":1,"purple-pink-roses-flowers-round-box-evie-sf":1,"exotic-tropical-flowers-sf":1,"box-ficta-sf":1,"roses-and-ranunculus-flowers-basket-flora-sf":1,"patricia-sf":1,"flowers-and-macaroons-sf":1,"forever-love-sf":1,"flowers-macarons-in-heart-box-freya-sf":1,"flowers-with-macaroons-and-toy-sf":1,"garden-roses-in-pink-box-sf":1,"box-gifita-sf":1,"floral-arrangement-in-a-pink-box-sf":1,"harmony-sf":1,"hemena-two-types-of-roses-with-solidago-carnations-and-chrysanthemums-sf":1,"100-mix-tulips-sf":1,"ionacolorful-dahlias-garden-roses-and-carnations-in-round-box-pink-clover-sf":1,"sunflower-with-roses-katrina-sf":1,"orchids-and-garden-roses-with-dahlias-sf":1,"blue-hydrangea-with-flowers-mix-in-round-box-beatrice-sf":1,"pink-and-beige-roses-bouquet-liyah-sf":1,"loli-arrangement-of-anemones-roses-and-dry-berry-flowers-in-round-box-sf":1,"large-blue-box-with-hydrangea-and-orchids-sf":1,"heart-flower-box-with-initials-sf":1,"loving-tribute-sf":1,"white-orchids-with-carnations-and-english-roses-flowers-arrangement-lucie-sf":1,"lunar-petals-sf":1,"200-red-roses-with-ceramic-vase-sf":1,"red-roses-with-mix-flowers-in-a-box-sf":1,"white-and-beige-roses-in-gray-vase-sf":1,"pink-and-white-carnations-flowers-with-roses-in-round-box-marie-sf":1,"marta-bright-arrangement-of-yellow-and-pink-roses-mini-chrysanthemums-and-carnations-in-round-box-sf":1,"memorial-bloom-sf":1,"memorial-ribbon-sf":1,"designers-choice-arrangement-los-angeles-florist-pink-clover-sf":1,"bouquet-with-purple-roses-and-mix-beautiful-flowers-sf":1,"moonlit-orchids-sf":1,"flowers-in-heart-box-sf":1,"white-orchids-and-roses-flowers-arrangement-nella-sf":1,"niam-arrangement-of-ranunculus-and-hydrangea-sf":1,"white-and-beige-roses-in-gray-vase-1-sf":1,"olesya-sf":1,"colourful-bouquet-of-red-and-orange-roses-dahlias-olivera-sf":1,"medley-orchids-plants-eight-stems-sf":1,"orchid-4-stems-sf":1,"mix-pink-and-white-roses-in-the-box-sf":1,"peach-paradise-sf":1,"pink-cloud-sf":1,"pink-heaven-sf":1,"mother-s-day-pink-in-bloom-sf":1,"pink-roses-sf":1,"white-and-beige-roses-in-the-high-vase-sf":1,"yellow-and-pink-roses-with-carnations-flowers-bouquet-yvonne-sf":1,"basket-white-prince-sf":1,"red-roses-sf":1,"rest-in-peace-sf":1,"rose-petals-sf":1,"rosy-garden-sf":1,"white-hydrangea-with-pink-roses-flowers-bouquet-roxanne-sf":1,"white-roses-and-carnations-flowers-bridal-bouquet-ruby-sf":1,"bride-bouquet-sf":1,"sana-arrangement-of-hydrangea-and-poppy-flower-sf":1,"small-teddy-bear-sf":1,"sunflowers-bouquet-los-angeles-florist-pink-clover-sf":1,"star-lux-sf":1,"luxe-white-bouquet-sf":1,"bouquet-of-sunflowers-sf":1,"sympathy-heart-pink-sf":1,"tamara-arrangement-of-sunflowers-chrysanthemums-sf":1,"box-tulsa-sf":1,"red-roses-with-orchids-sf":1,"valentine-sf":1,"velvet-valor-sf":1,"white-roses-sf":1,"yellow-roses-in-box-with-white-mix-flowers-sf":1,"orchid-plant-in-round-box-sf":1,"funeral-casket-peace-sf":1,"circle-spray-pinky-promise-sf":1,"circle-spray-blue-sf":1,"circle-spray-sf":1,"funeral-cross-white-lily-sf":1,"heart-stand-red-sf":1,"sympathy-casket-spray-sf":1,"broken-wedding-arch-sf":1,"designer-arch-sf":1,"flower-clouds-wedding-arch-sf":1,"round-wedding-arch-sf":1,"milana-flower-arrangement-sf":1},"hnl":{"white-arrangement-with-orchids-catherine-hnl":1,"100-roses-pink-clover-hnl":1,"balloons-hnl":1,"champagne-hnl":1,"sparkling-wine-hnl":1,"75-red-roses-bouquet-hnl":1,"white-roses-and-hydrangea-flowers-bridal-bouquet-adele-hnl":1,"alexandra-arrangement-of-garden-roses-hydrangea-stachys-and-carnations-in-round-box-hnl":1,"lilies-and-purple-roses-in-pink-box-hnl":1,"gorgeous-arrangement-of-dahlias-lilies-roses-amelita-hnl":1,"multicolor-bouquet-of-roses-with-carnations-flowers-aminah-hnl":1,"purple-and-pink-roses-with-carnations-flowers-arrangement-anastasia-hnl":1,"spring-bouquet-chamomile-and-peach-garden-roses-hnl":1,"arrangement-of-peonies-variety-of-roses-antonia-hnl":1,"orchids-with-lilies-and-roses-arleta-hnl":1,"gold-box-with-white-and-yellow-roses-hnl":1,"boxes-i-love-you-3-boxes-hnl":1,"box-with-anemones-rosesand-hnl":1,"boutonniere-hnl":1,"bright-box-hnl":1,"burgundy-box-hnl":1,"candy-box-hnl":1,"white-orchids-with-hydrangea-and-roses-flowers-in-round-box-chantelle-hnl":1,"50-red-roses-in-velvet-box-hnl":1,"chocolate-sweets-hnl":1,"orchids-flowers-with-mums-and-roses-in-round-box-christa-hnl":1,"bride-bouquet-1-hnl":1,"cora-hnl":1,"corsage-hnl":1,"orchids-and-hydrangeas-chrysanthemums-flowers-round-box-dale-hnl":1,"diana-hnl":1,"dolly-roses-with-greenery-hnl":1,"dora-arrangement-of-blue-hydrangea-stachys-and-roses-in-box-hnl":1,"lovely-box-hnl":1,"arrangement-with-anemones-hnl":1,"white-roses-dahlia-and-irises-enola-hnl":1,"eternal-love-hnl":1,"purple-pink-roses-flowers-round-box-evie-hnl":1,"exotic-tropical-flowers-hnl":1,"box-ficta-hnl":1,"roses-and-ranunculus-flowers-basket-flora-hnl":1,"patricia-hnl":1,"flowers-and-macaroons-hnl":1,"forever-love-hnl":1,"flowers-macarons-in-heart-box-freya-hnl":1,"flowers-with-macaroons-and-toy-hnl":1,"garden-roses-in-pink-box-hnl":1,"box-gifita-hnl":1,"floral-arrangement-in-a-pink-box-hnl":1,"harmony-hnl":1,"valentine-s-heart-box-hnl":1,"hemena-two-types-of-roses-with-solidago-carnations-and-chrysanthemums-hnl":1,"100-mix-tulips-hnl":1,"ionacolorful-dahlias-garden-roses-and-carnations-in-round-box-pink-clover-hnl":1,"sunflower-with-roses-katrina-hnl":1,"orchids-and-garden-roses-with-dahlias-hnl":1,"blue-hydrangea-with-flowers-mix-in-round-box-beatrice-hnl":1,"pink-and-beige-roses-bouquet-liyah-hnl":1,"large-blue-box-with-hydrangea-and-orchids-hnl":1,"heart-flower-box-with-initials-hnl":1,"loving-tribute-hnl":1,"white-orchids-with-carnations-and-english-roses-flowers-arrangement-lucie-hnl":1,"lunar-petals-hnl":1,"200-red-roses-with-ceramic-vase-hnl":1,"red-roses-with-mix-flowers-in-a-box-hnl":1,"white-and-beige-roses-in-gray-vase-hnl":1,"pink-and-white-carnations-flowers-with-roses-in-round-box-marie-hnl":1,"marta-bright-arrangement-of-yellow-and-pink-roses-mini-chrysanthemums-and-carnations-in-round-box-hnl":1,"memorial-bloom-hnl":1,"memorial-ribbon-hnl":1,"designers-choice-arrangement-los-angeles-florist-pink-clover-hnl":1,"bouquet-with-purple-roses-and-mix-beautiful-flowers-hnl":1,"moonlit-orchids-hnl":1,"flowers-in-heart-box-hnl":1,"white-orchids-and-roses-flowers-arrangement-nella-hnl":1,"niam-arrangement-of-ranunculus-and-hydrangea-hnl":1,"white-and-beige-roses-in-gray-vase-1-hnl":1,"olesya-hnl":1,"colourful-bouquet-of-red-and-orange-roses-dahlias-olivera-hnl":1,"medley-orchids-plants-eight-stems-hnl":1,"orchid-4-stems-hnl":1,"mix-pink-and-white-roses-in-the-box-hnl":1,"peach-paradise-hnl":1,"pink-cloud-hnl":1,"pink-heaven-hnl":1,"mother-s-day-pink-in-bloom-hnl":1,"pink-roses-hnl":1,"white-and-beige-roses-in-the-high-vase-hnl":1,"yellow-and-pink-roses-with-carnations-flowers-bouquet-yvonne-hnl":1,"basket-white-prince-hnl":1,"red-roses-hnl":1,"rest-in-peace-hnl":1,"rose-petals-hnl":1,"rosy-garden-hnl":1,"white-hydrangea-with-pink-roses-flowers-bouquet-roxanne-hnl":1,"white-roses-and-carnations-flowers-bridal-bouquet-ruby-hnl":1,"bride-bouquet-hnl":1,"sana-arrangement-of-hydrangea-and-poppy-flower-hnl":1,"small-teddy-bear-hnl":1,"sunflowers-bouquet-los-angeles-florist-pink-clover-hnl":1,"star-lux-hnl":1,"luxe-white-bouquet-hnl":1,"bouquet-of-sunflowers-hnl":1,"sympathy-heart-pink-hnl":1,"tamara-arrangement-of-sunflowers-chrysanthemums-hnl":1,"box-tulsa-hnl":1,"red-roses-with-orchids-hnl":1,"valentine-hnl":1,"velvet-valor-hnl":1,"white-roses-hnl":1,"yellow-roses-in-box-with-white-mix-flowers-hnl":1,"orchid-plant-in-round-box-hnl":1,"funeral-casket-peace-hnl":1,"funeral-cross-white-lily-hnl":1,"heart-stand-red-hnl":1,"broken-wedding-arch-hnl":1,"designer-arch-hnl":1,"flower-clouds-wedding-arch-hnl":1,"milana-flower-arrangement-hnl":1}};

  function rewriteLink(link, region) {
    if (!region || String(region).length === 0) return; // never rewrite with empty region (would make "harmony-")
    if (isRegionalCollectionPage() && link.closest('#product-grid, #ProductGridContainer')) return; // keep regional collection grid links intact
    var href = link.getAttribute('href');
    if (!href || (href.indexOf('/collections/') < 0 && href.indexOf('/products/') < 0)) return;
    if (link.closest('#zip-code-popup')) return;

    var match = href.match(/^(\/(?:collections|products)\/)([^/?]+)([^]*)$/);
    if (!match) return;
    var prefix = match[1];
    var handle = match[2];
    var rest = match[3];
    var base = getHandleBase(handle);
    if (!base) return;

    var newHandle = region === 'la' ? base : (base + '-' + region);
    if (newHandle === handle) return;

    // PCREGION FALLBACK: for collection links, only rewrite when the regional twin resolves.
    if (region !== 'la' && prefix.indexOf('collections') >= 0) {
      var wl = PC_TWIN_COLL[region];
      if (wl && !wl[newHandle]) return; // no twin/redirect -> keep base link, never 404
    }
    // Same guard for PRODUCT links: only swap to an ACTIVE regional twin.
    // Prevents 404s on natively-regional handles (e.g. ...-honolulu) and drafted twins.
    if (region !== 'la' && prefix.indexOf('products') >= 0) {
      var pw = PC_TWIN_PROD[region];
      if (!pw || !pw[newHandle]) return;
    }

    var isBrokenHandle = (handle.slice(-1) === '-' && !/-(?:la|sf|hnl|vc)$/i.test(handle));
    if (!link.getAttribute(ORIGINAL_HREF) && !isBrokenHandle) {
      link.setAttribute(ORIGINAL_HREF, href);
    }
    link.setAttribute('href', prefix + newHandle + rest);
    link.setAttribute(REWRITTEN_ATTR, region);
  }

  // Pricing note:
  // We no longer adjust prices via JavaScript.
  // Each city has its own duplicated products with correct prices in Shopify,
  // so we keep theme-rendered prices as-is.
  function applyPrices() {}

  function stripCitySuffix(text) {
    if (!text) return text;
    return String(text).replace(/\s*-\s*(Los Angeles|San Francisco|Honolulu|Ventura County)\s*$/i, '').trim();
  }

  /** Hide city suffix in product titles across site (cards, predictive search, etc.). */
  function hideCityNamesInTitles() {
    var nodes = document.querySelectorAll(
      [
        '.card__heading a.full-unstyled-link',
        '.card__heading a',
        '.predictive-search__list-item a',
        '[id^="predictive-search-option-product-"] a',
        'a.full-unstyled-link'
      ].join(',')
    );

    nodes.forEach(function (el) {
      if (el.closest('#zip-code-popup')) return;
      if (el.classList && (el.classList.contains('zip-popup-city-btn') || el.classList.contains('zip-popup-trigger'))) return;

      // Don't destroy markup / links: only update plain-text elements.
      if (el.querySelector && el.querySelector('*')) return;

      var t = el.textContent;
      var cleaned = stripCitySuffix(t);
      if (cleaned !== t) el.textContent = cleaned;
    });
  }

  /** Restore link to original href (when region is "other"). Never restore to broken "handle-" URL. */
  function restoreLink(link) {
    var orig = link.getAttribute(ORIGINAL_HREF);
    if (!orig) return;
    var handleMatch = orig.match(/\/(?:collections|products)\/([^/?]+)/);
    if (handleMatch && handleMatch[1].slice(-1) === '-' && !/-(?:la|sf|hnl|vc)$/i.test(handleMatch[1])) return;
    link.setAttribute('href', orig);
    link.removeAttribute(ORIGINAL_HREF);
    link.removeAttribute(REWRITTEN_ATTR);
  }

  /** Rewrite all collection/product links to current region, or restore if region is other */
  function rewriteLinksToRegion(region) {
    var links = document.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]');
    links.forEach(function (link) {
      if (link.closest('#zip-code-popup')) return;
      if (region) {
        rewriteLink(link, region);
      } else {
        restoreLink(link);
      }
    });
    rewritePageLinks(region);
  }

  /* Regional cluster PAGES: header/menu links point at the LA versions; swap the
     region slug so e.g. wedding-flowers-los-angeles -> wedding-flowers-honolulu.
     Regional twins for all five clusters exist for all six regions (wave 1). */
  var PC_PAGE_CLUSTERS = ['same-day-flower-delivery', 'wedding-flowers',
    'event-floral-setup-installation', 'corporate-flowers', 'flower-subscription'];
  var PC_PAGE_REGION_SLUG = { la: 'los-angeles', oc: 'orange-county', ie: 'inland-empire',
    sf: 'san-francisco', vc: 'ventura-county', hnl: 'honolulu' };
  var PC_PAGE_SLUGS = Object.keys(PC_PAGE_REGION_SLUG).map(function(k){ return PC_PAGE_REGION_SLUG[k]; });
  function rewritePageLinks(region) {
    var slug = PC_PAGE_REGION_SLUG[region];
    var links = document.querySelectorAll('a[href*="/pages/"]');
    links.forEach(function (link) {
      if (link.closest('#zip-code-popup')) return;
      var orig = link.getAttribute('data-pc-orig-page') || link.getAttribute('href');
      if (!orig) return;
      var m = orig.match(/\/pages\/([a-z0-9-]+)/);
      if (!m) return;
      var handle = m[1];
      /* 2026-10-24: подменяем только ссылки на LA-версии кластера (так задумано: меню и футер ведут на LA).
         Явные ссылки на другой регион (меню «Wedding by City», списки «Weddings in Honolulu») оставляем как есть,
         иначе в режиме LA все три города вели на одну страницу. Ссылки с data-pc-noregion не трогаем никогда. */
      if (link.closest('[data-pc-noregion]')) return;
      /* 2026-10-24: пункт меню «Funeral» ведёт на СТРАНИЦУ funeral-flowers-delivery-la,
         а региональных страниц для похорон нет — есть только коллекции. Поэтому для SF и Гавайев
         уводим на региональную коллекцию, в LA оставляем страницу как есть. */
      if (handle === 'funeral-flowers-delivery-la') {
        if (!link.getAttribute('data-pc-orig-page')) link.setAttribute('data-pc-orig-page', orig);
        if (region === 'sf' || region === 'hnl') {
          link.setAttribute('href', '/collections/funeral-flowers-delivery-' + region);
        } else {
          link.setAttribute('href', link.getAttribute('data-pc-orig-page'));
        }
        return;
      }
      var basePart = null;
      for (var i = 0; i < PC_PAGE_CLUSTERS.length; i++) {
        if (handle === PC_PAGE_CLUSTERS[i] + '-los-angeles') { basePart = PC_PAGE_CLUSTERS[i]; break; }
      }
      if (!basePart) return;
      if (!link.getAttribute('data-pc-orig-page')) link.setAttribute('data-pc-orig-page', orig);
      if (!slug) { link.setAttribute('href', orig); return; }
      link.setAttribute('href', orig.replace(/\/pages\/[a-z0-9-]+/, '/pages/' + basePart + '-' + slug));
    });
  }

  function applyRegion(city) {
    var region = cityToRegion(city);
    document.body.setAttribute(BODY_ATTR, region || 'other');
    document.body.classList.remove('store-city-la', 'store-city-sf', 'store-city-hnl', 'store-city-other');
    document.body.classList.add('store-city-' + (region || 'other'));
    rewriteLinksToRegion(region);
    hideDuplicateCards(region || 'la');
    applyPrices(city);
    hideCityNamesInTitles();
  }

  function runPopup() {
    /* owner/QA helper: ?pc_reset_region=1 wipes the saved region (cookie + cart attrs)
       and reloads — simulates a brand-new visitor to test the locked popup. */
    if (/[?&]pc_reset_region=1/.test(window.location.search)) {
      setCookie(COOKIE_NAME, '', -1);
      try { localStorage.removeItem('pc_selected_zip'); } catch (e) {}
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { store_city: '', selected_city: '' } }) })
        .catch(function () {})
        .then(function () {
          var qs = window.location.search.replace(/[?&]pc_reset_region=1/, '').replace(/^&/, '?');
          window.location.replace(window.location.pathname + qs + window.location.hash);
        });
      return;
    }
    var popup = document.getElementById('zip-code-popup');
    var input = document.getElementById('zip-code-input');
    var btn = document.getElementById('zip-code-submit');
    var err = document.getElementById('zip-code-error');
    if (!popup || !input || !btn) return;

    /* Until the visitor picks a delivery area the popup is NOT dismissable —
       prevents accidental cross-region orders (owner 2026-07-24). */
    var mustChoose = false;

    /* Accessibility (ADA fixes 2026-10-14): the picker is a real modal dialog — focus moves inside on open,
       Tab cycles within it, Escape closes it when it is dismissable, focus returns to the opener on close. */
    var box = popup.querySelector('.zip-popup-box') || popup;
    var lastFocus = null;
    function isOpen() { return popup.classList.contains('zip-popup--open'); }
    function focusables() {
      return Array.prototype.filter.call(box.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
      });
    }
    function trapKeys(e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { if (!mustChoose) { e.preventDefault(); closePopup(); } return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (!box.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
      if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    }
    function keepFocus(e) { if (isOpen() && !box.contains(e.target)) { var f = focusables(); if (f.length) f[0].focus(); } }

    function closePopup() {
      if (mustChoose) return;
      popup.classList.remove('zip-popup--open');
      document.body.classList.remove('zip-popup-open');
      popup.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', trapKeys, true);
      document.removeEventListener('focusin', keepFocus, true);
      if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) { try { lastFocus.focus(); } catch (e) {} }
      lastFocus = null;
    }

    function openPopup() {
      ensureData(); // prefetch ZIP tables as soon as the picker is visible
      popup.classList.toggle('zip-popup--locked', mustChoose);
      popup.classList.add('zip-popup--open');
      document.body.classList.add('zip-popup-open');
      popup.setAttribute('aria-hidden', 'false');
      if (!lastFocus) lastFocus = document.activeElement;
      document.addEventListener('keydown', trapKeys, true);
      document.addEventListener('focusin', keepFocus, true);
      var title = document.getElementById('zip-popup-title');
      setTimeout(function () { try { (title || input).focus(); } catch (e) {} }, 40);
    }

    /* регион → профиль Klaviyo, чтобы письма шли со своей студией, телефоном и катоффом.
       Работает и для тех, кто ещё не покупал: Klaviyo склеит анонимный профиль при подписке. */
    var PC_KLAVIYO_REGION = {
      los_angeles:   {r:'la',  n:'Los Angeles',    p:'(424) 303-2205', s:'315 E 8th St, Ste 102, Los Angeles, CA 90014',      c:'5:30 PM PT',  rv:'https://maps.app.goo.gl/qZkQoeih3ZwhhZ7k7'},
      orange_county: {r:'oc',  n:'Orange County',  p:'(657) 300-4404', s:'2646 Dupont Dr, Ste 50, Irvine, CA 92612 (opening soon)', c:'4:30 PM PT', rv:'https://maps.app.goo.gl/qZkQoeih3ZwhhZ7k7'},
      inland_empire: {r:'ie',  n:'Inland Empire',  p:'(951) 666-8848', s:'402 S Milliken Ave, Ste B, Ontario, CA 91761 (opening soon)', c:'4:30 PM PT', rv:'https://maps.app.goo.gl/qZkQoeih3ZwhhZ7k7'},
      san_francisco: {r:'sf',  n:'San Francisco',  p:'(415) 360-1333', s:'977 Ellis St, San Francisco, CA 94109',              c:'3 PM PT',     rv:'https://maps.app.goo.gl/qZkQoeih3ZwhhZ7k7'},
      ventura:       {r:'vc',  n:'Ventura County', p:'(805) 870-9996', s:'3303 W Kimber Dr, Unit D, Newbury Park, CA 91320',   c:'4:30 PM PT',  rv:'https://maps.app.goo.gl/qZkQoeih3ZwhhZ7k7'},
      honolulu:      {r:'hnl', n:'Honolulu',       p:'(808) 808-6616', s:'98-027 Hekaha St, Ste 10, Aiea, HI 96701',           c:'4:30 PM HST', rv:'https://maps.app.goo.gl/2d4D6d1E3HMks2k28'}
    };
    function pushRegionToKlaviyo(city) {
      try {
        var R = PC_KLAVIYO_REGION[city];
        if (!R) return;
        var props = {
          pc_region: R.r, pc_region_name: R.n, pc_phone: R.p,
          pc_studio: R.s, pc_cutoff: R.c, pc_city_slug: city, pc_review_link: R.rv
        };
        if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
          window.klaviyo.identify(props);
        } else if (window._learnq) {
          window._learnq.push(['identify', props]);
        } else {
          window._learnq = window._learnq || [];
          window._learnq.push(['identify', props]);
        }
      } catch (e) {}
    }

    function applyCity(city) {
      mustChoose = false;
      popup.classList.remove('zip-popup--locked');
      setCookie(COOKIE_NAME, city, COOKIE_DAYS);
      pushRegionToKlaviyo(city);
      closePopup();
      if (typeof window.zipCityApplied === 'function') window.zipCityApplied(city);
      redirectWithCitySaved(city);
    }

    var HUB_URLS = {
      los_angeles: '/',
      orange_county: '/pages/orange-county-florist',
      inland_empire: '/pages/inland-empire-florist',
      san_francisco: '/pages/san-francisco',
      ventura: '/pages/ventura-florist',
      honolulu: '/pages/honolulu-florist'
    };
    function getReturnToUrlForCity(city) {
      var p = window.location.pathname;
      /* From the popup, region choice leads to the region hub — except mid-shopping
         (product/collection/cart pages keep the visitor where they are). */
      var shopping = p.indexOf('/products/') === 0 || p.indexOf('/collections/') === 0 || p.indexOf('/cart') === 0 || p.indexOf('/blogs/') === 0; // blog readers stay on the article
      if (!shopping && HUB_URLS[city]) {
        if (city === 'los_angeles' && isHomePath()) return homeUrlWithCityQuery(city);
        return HUB_URLS[city];
      }
      if (isHomePath()) {
        return homeUrlWithCityQuery(city);
      }
      return p + (window.location.search || '') + (window.location.hash || '');
    }

    function redirectWithCitySaved(city) {
      // IMPORTANT:
      // Liquid can only read the selected city from cart.attributes.
      // Using /cart/update?...&return_to=... guarantees attributes are persisted BEFORE the next page render.
      var shortCity = city === 'los_angeles' ? 'la' : (city === 'san_francisco' ? 'sf' : (city === 'honolulu' ? 'hnl' : (city === 'ventura' ? 'vc' : (city === 'orange_county' ? 'oc' : (city === 'inland_empire' ? 'ie' : 'other')))));
      var returnTo = getReturnToUrlForCity(city);

      // Build query string without relying on URLSearchParams (older browsers).
      var qs =
        'attributes%5Bstore_city%5D=' + encodeURIComponent(city) +
        '&attributes%5Bselected_city%5D=' + encodeURIComponent(shortCity) +
        '&return_to=' + encodeURIComponent(returnTo);

      window.location.href = '/cart/update?' + qs;
    }

    function saveCityToCart(city) {
      var attr = { store_city: city };
      var shortCity = city === 'los_angeles' ? 'la' : (city === 'san_francisco' ? 'sf' : (city === 'honolulu' ? 'hnl' : (city === 'ventura' ? 'vc' : (city === 'orange_county' ? 'oc' : (city === 'inland_empire' ? 'ie' : 'other')))));
      attr.selected_city = shortCity;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attr })
      }).catch(function () {});
    }

    function pickResult(city, zip) {
      if (zip) localStorage.setItem('pc_selected_zip', zip);
      err && (err.textContent = '');
      applyCity(city);
    }
    btn.addEventListener('click', function () {
      err && (err.textContent = '');
      ensureData(function () {
        var res = smartResolve(input.value);
        if (res.error) { err && (err.textContent = res.error); return; }
        pickResult(res.city, res.zip);
      });
    });
    var results = document.getElementById('zip-search-results');
    /* Google Places address autocomplete (2026-07-05). Key is domain-restricted to Places API only. */
    var PLACES_KEY = 'AIzaSyCyr_9h6iCIYQPfsLRZG-iOrPiMv7LjGU8';
    var placesSession = null, placesTimer = null, placesRows = [], placesQuery = '';
    var censusRows = [], censusQuery = '', censusN = 0;
    function uuid4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
    function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
    function looksLikeAddress(q) {
      var t = String(q || '').trim();
      return /\d/.test(t) && /[a-z]/i.test(t) && t.length >= 6;
    }
    function fetchAddressSuggestions(q) {
      if (!window.fetch) return;
      if (!placesSession) placesSession = uuid4();
      fetch('https://places.googleapis.com/v1/places:autocomplete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Goog-Api-Key': PLACES_KEY },
        body: JSON.stringify({ input: q, includedRegionCodes: ['US'], sessionToken: placesSession })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if ((input.value || '').trim() !== q) return; /* stale response */
        placesQuery = q;
        placesRows = [];
        var sugg = d.suggestions || [];
        for (var i = 0; i < sugg.length && placesRows.length < 4; i++) {
          var p = sugg[i].placePrediction;
          if (p && p.placeId) placesRows.push({ label: (p.text && p.text.text) || '', placeId: p.placeId });
        }
        if (!placesRows.length) { censusSuggest(q); return; }
        paintRows();
      }).catch(function () { censusSuggest(q); });
    }
    /* PC FALLBACK 2026-07-17: Google Places key returns 403 — free US Census geocoder via JSONP.
       Same UX: address rows with ZIP resolution; removed automatically if Google works again. */
    function censusSuggest(q) {
      var cb = 'pcCensusCb' + (++censusN);
      var s = document.createElement('script');
      window[cb] = function (d) {
        try {
          if ((input.value || '').trim() !== q) return;
          var out = [];
          var ms = (d && d.result && d.result.addressMatches) || [];
          for (var i = 0; i < ms.length && out.length < 4; i++) {
            var zc = ms[i].addressComponents && ms[i].addressComponents.zip;
            if (ms[i].matchedAddress) out.push({ label: ms[i].matchedAddress, zip: zc || null });
          }
          censusRows = out; censusQuery = q; paintRows();
        } finally { try { delete window[cb]; } catch (e) {} if (s.parentNode) s.parentNode.removeChild(s); }
      };
      s.onerror = function () { try { delete window[cb]; } catch (e) {} if (s.parentNode) s.parentNode.removeChild(s); };
      s.src = 'https://geocoding.geo.census.gov/geocoder/locations/onelineaddress?address=' + encodeURIComponent(q) + '&benchmark=Public_AR_Current&format=jsonp&callback=' + cb;
      document.head.appendChild(s);
    }
    function resolvePlace(placeId) {
      var sess = placesSession;
      placesSession = null; /* session ends with the details call */
      err && (err.textContent = '');
      fetch('https://places.googleapis.com/v1/places/' + encodeURIComponent(placeId) + (sess ? '?sessionToken=' + encodeURIComponent(sess) : ''), {
        headers: { 'X-Goog-Api-Key': PLACES_KEY, 'X-Goog-FieldMask': 'addressComponents' }
      }).then(function (r) { return r.json(); }).then(function (d) {
        var zip = null, comps = d.addressComponents || [];
        for (var i = 0; i < comps.length; i++) {
          if ((comps[i].types || []).indexOf('postal_code') >= 0) { zip = comps[i].longText || comps[i].shortText; break; }
        }
        ensureData(function () {
          var region = zip ? getCityByZip(zip) : null;
          if (region && region !== 'other') {
            pickResult(region, zip);
          } else if (zip) {
            err && (err.textContent = "Sorry, we don't deliver to " + zip + ' yet.');
          } else {
            err && (err.textContent = "We couldn't confirm this address — try your ZIP code.");
          }
        });
      }).catch(function () {
        err && (err.textContent = 'Address check failed — try your ZIP code.');
      });
    }
    var localRows = [];
    function paintRows() {
      if (!results) return;
      if (!zipData()) { ensureData(paintRows); return; }
      var q = (input.value || '').trim();
      var html = '';
      for (var r = 0; r < localRows.length; r++) {
        var row = localRows[r];
        if (row.ok) {
          html += '<div class="zip-search-opt" data-region="' + row.region + '" data-zip="' + (row.zip || '') + '"><span>' + escapeHtml(row.label) + '</span><span class="zip-search-ok">✓ We deliver here</span></div>';
        } else {
          html += '<div class="zip-search-opt zip-search-no"><span>' + escapeHtml(row.label) + '</span><span class="zip-search-nope">✗ Not in our delivery area yet</span></div>';
        }
      }
      if (placesQuery === q) {
        for (var a = 0; a < placesRows.length; a++) {
          html += '<div class="zip-search-opt zip-search-addr" data-place-id="' + escapeHtml(placesRows[a].placeId) + '"><span>📍 ' + escapeHtml(placesRows[a].label) + '</span><span class="zip-search-check">check ›</span></div>';
        }
      }
      if (censusQuery === q && !placesRows.length) {
        for (var c2 = 0; c2 < censusRows.length; c2++) {
          var cz = censusRows[c2].zip; var creg = cz ? getCityByZip(cz) : null;
          if (creg && creg !== 'other') {
            html += '<div class="zip-search-opt" data-region="' + creg + '" data-zip="' + cz + '"><span>📍 ' + escapeHtml(censusRows[c2].label) + '</span><span class="zip-search-ok">✓ We deliver here</span></div>';
          } else {
            html += '<div class="zip-search-opt zip-search-no"><span>📍 ' + escapeHtml(censusRows[c2].label) + '</span><span class="zip-search-nope">✗ Not in our delivery area yet</span></div>';
          }
        }
      }
      if (!html) { results.style.display = 'none'; results.innerHTML = ''; return; }
      results.innerHTML = html;
      results.style.display = 'block';
    }
    function renderResults() {
      if (!zipData()) { ensureData(renderResults); return; }
      var q = (input.value || '').trim();
      localRows = [];
      var zm = q.match(/\b(\d{5})\b/);
      if (zm) {
        var zc = getCityByZip(zm[1]);
        if (zc && zc !== 'other') {
          localRows.push({ label: 'ZIP ' + zm[1] + ' — ' + getCityDisplayName(zc), ok: true, region: zc, zip: zm[1] });
        } else {
          var cm0 = findCityMatches(q, true).slice(0, 3);
          for (var m0 = 0; m0 < cm0.length; m0++) {
            localRows.push({ label: cm0[m0].name + ' — ' + getCityDisplayName(cm0[m0].region), ok: true, region: cm0[m0].region, zip: cm0[m0].zip });
          }
          if (!cm0.length && !looksLikeAddress(q)) localRows.push({ label: 'ZIP ' + zm[1], ok: false });
        }
      } else if (q.length >= 2 && !/^\d+$/.test(q)) {
        var ms = findCityMatches(q, false);
        if (!ms.length) ms = findCityMatches(q, true).slice(0, 3);
        for (var i = 0; i < ms.length && i < 4; i++) {
          localRows.push({ label: ms[i].name + ' — ' + getCityDisplayName(ms[i].region), ok: true, region: ms[i].region, zip: ms[i].zip });
        }
      }
      if (placesQuery !== q) placesRows = [];
      if (censusQuery !== q) censusRows = [];
      paintRows();
      if (placesTimer) clearTimeout(placesTimer);
      if (looksLikeAddress(q)) {
        placesTimer = setTimeout(function () { fetchAddressSuggestions(q); }, 300);
      }
    }
    input.addEventListener('focus', function () { ensureData(); });
    if (results) {
      input.addEventListener('input', renderResults);
      results.addEventListener('click', function (e) {
        var opt = e.target.closest ? e.target.closest('.zip-search-opt') : null;
        if (!opt) return;
        var pid = opt.getAttribute('data-place-id');
        if (pid) { resolvePlace(pid); return; }
        if (opt.getAttribute('data-region')) pickResult(opt.getAttribute('data-region'), opt.getAttribute('data-zip') || null);
      });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') btn.click();
    });

    popup.querySelectorAll('.zip-popup-close').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });

    popup.querySelectorAll('.zip-popup-city-btn').forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        /* Enter / Space on the region card itself (not on the "all N cities" toggle or a city link) picks the region */
        if (e.target !== el) return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          var city = el.getAttribute('data-city');
          if (city) { err && (err.textContent = ''); applyCity(city); }
        }
      });
      el.addEventListener('click', function (e) {
        var city = el.getAttribute('data-city');
        var link = e && e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (link && el.contains(link)) {
          /* A city-page link inside the region card: remember the region, then let the browser follow
             the link. Previously the card-level redirect to the region hub swallowed these clicks. */
          if (city) { setCookie(COOKIE_NAME, city, COOKIE_DAYS); pushRegionToKlaviyo(city); }
          return;
        }
        if (city) { err && (err.textContent = ''); applyCity(city); }
      });
    });

    document.querySelectorAll('[data-open-zip-popup], #zip-popup-trigger').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openPopup(); });
    });

    var saved = getCityForRewrite();
    if (saved && cityToRegion(saved)) {
      if (!getCookie(COOKIE_NAME) && getCityFromUrl()) setCookie(COOKIE_NAME, saved, COOKIE_DAYS);
      closePopup();
      applyRegion(saved);
      regionAppliedAtInit = true;
      // Best-effort sync for future server-side renders (no redirect here).
      if (getCookie(COOKIE_NAME)) saveCityToCart(saved);
      updateTriggerLabel(saved);
      if (isHomePath()) {
        if (saved === 'los_angeles' && (window.location.search || window.location.hash)) {
          history.replaceState(null, '', '/');
        } else if (saved === 'honolulu' || saved === 'san_francisco' || saved === 'ventura' || saved === 'orange_county' || saved === 'inland_empire') {
          var prettyHome = homeUrlWithCityQuery(saved);
          var normPath = (window.location.pathname || '/').replace(/\/$/, '') || '/';
          var params = typeof URLSearchParams !== 'undefined' && window.location.search ? new URLSearchParams(window.location.search) : null;
          var fromQuery = params ? slugToCity(params.get('city')) : null;
          var hashSeg = (window.location.hash || '').replace(/^#/, '').split(/[?&]/)[0];
          var fromHash = hashSeg ? slugToCity(decodeURIComponent(hashSeg)) : null;
          var queryOk = fromQuery === saved;
          var pathOk = normPath === '/' || normPath === '';
          if (!pathOk || !queryOk || fromHash || window.location.hash) {
            history.replaceState(null, '', prettyHome);
          }
        }
      }
    } else if (/^\/blogs(\/|$)/.test(window.location.pathname || '')) {
      // Blog readers are never forced to pick a region (owner rule 2026-09-02):
      // articles render with the default (LA) catalog; the header pin still opens the picker, unlocked.
      mustChoose = false;
    } else {
      mustChoose = true;
      if (isHomePath()) {
        setTimeout(function () { openPopup(); }, 3000);
      } else {
        openPopup();
      }
    }

    var trigger = document.getElementById('zip-popup-trigger');
    if (trigger) {
      var searchEl = document.querySelector('.global-header .header__search, header .header__search, .header__search, [class*="global-header"] details-modal, [class*="header"] [class*="search"]');
      var iconsWrap = document.querySelector('.header__icons, .header-icons, [class*="global-header"] .header__icons');
      var ghActions = document.querySelector('.global-header .gh-actions, [class*="global-header"] .gh-actions');
      if (ghActions && ghActions.parentNode) {
        ghActions.insertBefore(trigger, ghActions.firstChild);
        trigger.classList.add('gh-inline');
      } else if (iconsWrap) {
        iconsWrap.insertBefore(trigger, iconsWrap.firstChild);
        trigger.classList.add('gh-inline');
      } else if (searchEl && searchEl.parentNode) {
        if (searchEl.nextSibling) {
          searchEl.parentNode.insertBefore(trigger, searchEl.nextSibling);
        } else {
          searchEl.parentNode.appendChild(trigger);
        }
        trigger.classList.add('gh-inline');
      }
      (function () {
        function isLightBg(el) {
          if (!el) return false;
          var style = window.getComputedStyle(el);
          var bg = style.backgroundColor;
          var opacity = parseFloat(style.opacity);
          if (bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') {
            var parent = el.parentElement;
            return parent ? isLightBg(parent) : false;
          }
          var m = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
          if (m) {
            var r = parseInt(m[1], 10), g = parseInt(m[2], 10), b = parseInt(m[3], 10);
            return (r * 0.299 + g * 0.587 + b * 0.114) > 200;
          }
          if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(bg)) {
            var hex = bg.slice(1).length === 3 ? bg.slice(1).replace(/./g, '$&$&') : bg.slice(1);
            var r = parseInt(hex.slice(0, 2), 16), g = parseInt(hex.slice(2, 4), 16), b = parseInt(hex.slice(4, 6), 16);
            return (r * 0.299 + g * 0.587 + b * 0.114) > 200;
          }
          return false;
        }
        function updateTriggerLightBg() {
          if (!trigger || !trigger.classList.contains('gh-inline')) return;
          var header = trigger.closest('header, [class*="header"], [class*="Header"]');
          if (isLightBg(header || trigger.parentElement)) {
            trigger.classList.add('light-bg');
          } else {
            trigger.classList.remove('light-bg');
          }
        }
        updateTriggerLightBg();
        var scrollT = 0;
        window.addEventListener('scroll', function () {
          if (scrollT) clearTimeout(scrollT);
          scrollT = setTimeout(function () {
            scrollT = null;
            updateTriggerLightBg();
          }, 80);
        }, { passive: true });
      })();
    }

    window.openZipPopup = openPopup;
  }

  var regionAppliedAtInit = false;
  var rewriteDebounceTimer;
  function scheduleRewriteForNewContent() {
    if (rewriteDebounceTimer) clearTimeout(rewriteDebounceTimer);
    rewriteDebounceTimer = setTimeout(function () {
      rewriteDebounceTimer = null;
      var city = getCityForRewrite();
      if (city) applyRegion(city);
      else hideDuplicateCards('la');
      hideCityNamesInTitles();
    }, 150);
  }

  function observeDynamicContent() {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var list = mutations[i].addedNodes;
        for (var j = 0; j < list.length; j++) {
          var node = list[j];
          if (node.nodeType !== 1) continue;
          if (node.querySelector && (node.querySelector('a[href*="/products/"]') || node.querySelector('a[href*="/collections/"]'))) {
            scheduleRewriteForNewContent();
            break;
          }
          if (node.getAttribute && node.getAttribute('href') && (node.getAttribute('href').indexOf('/products/') >= 0 || node.getAttribute('href').indexOf('/collections/') >= 0)) {
            scheduleRewriteForNewContent();
            break;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    runPopup();
    observeDynamicContent();
    if (!regionAppliedAtInit) { // runPopup already ran the same pass for a saved region
      var _c = getCityForRewrite();
      hideDuplicateCards((_c && cityToRegion(_c)) || 'la');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.getZipCity = getCookie.bind(null, COOKIE_NAME);
  window.getCityByZip = getCityByZip;
  window.cityToRegion = cityToRegion;
  window.applyRegion = applyRegion;
  window.applyPrices = applyPrices;
  window.rewriteLinksToRegion = rewriteLinksToRegion;
  // Backwards compat: some older code referenced this symbol.
  window.adjustPriceForNonLA = function () {};

  // === LOCAL HEADING BY ZIP CODE (names table lives in zip-city-data.js) ===

  function getLocalName(zip) {
    var d = zipData();
    if (!d) { ensureData(); return null; }
    return d.ZIP_LOCAL_NAMES[String(zip)] || null;
  }

  function updateHeroHeading(zip) {
    if (!zipData()) { ensureData(function () { updateHeroHeading(zip); }); return; }
    var localName = getLocalName(zip);
    if (!localName) return;

    var headingText = localName.toUpperCase() + ' FLORIST';

    var blocks = document.querySelectorAll('.region-slideshow');
    var visibleBlock = null;
    for (var i = 0; i < blocks.length; i++) {
      if (getComputedStyle(blocks[i]).display !== 'none') {
        visibleBlock = blocks[i];
        break;
      }
    }
    if (!visibleBlock) return;

    var heading = visibleBlock.querySelector('.ami-slideshow__item-content h1, .ami-slideshow__item-content h2');
    if (heading) heading.innerHTML = '<strong>' + headingText + '</strong>';

    var subtitle = visibleBlock.querySelector('.ami-slideshow__item-content aside h3');
    if (subtitle) subtitle.innerHTML = '<strong>Event decorations and flower delivery in ' + localName + '</strong>';
  }

  document.addEventListener('click', function(e) {
    var btn = document.getElementById('zip-code-submit');
    if (!btn) return;
    if (e.target === btn || (e.target.closest && e.target.closest('#zip-code-submit'))) {
      var input = document.getElementById('zip-code-input');
      var zip = input ? (input.value || '').trim() : '';
      if (zip && /^\d{5}$/.test(zip)) {
        localStorage.setItem('pc_selected_zip', zip);
      }
    }
  }, true);

  var CITY_PHONES = {
    la: '(424) 303-2205',
    sf: '(415) 360-1333',
    hnl: '(808) 808-6616',
    vc: '(805) 870-9996',
    oc: '(657) 300-4404',
    ie: '(951) 666-8848'
  };

  function updateAnnouncementPhone(city) {
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    else if (city === 'orange_county' || city === 'oc') suffix = 'oc';
    else if (city === 'inland_empire' || city === 'ie') suffix = 'ie';
    var phone = CITY_PHONES[suffix] || CITY_PHONES.la;
    var textEl = document.getElementById('announcement-phone-text');
    var linkEl = document.getElementById('announcement-phone-link');
    if (textEl) textEl.textContent = phone;
    if (linkEl) linkEl.href = 'tel:+1' + phone.replace(/[^0-9]/g, '');
  }

  var origApplyCity = window.applyRegion;
  window.applyRegion = function(city) {
    if (origApplyCity) origApplyCity(city);
    showCityTextSections(city);
    updateAnnouncementPhone(city);
    updateCollectionRegion(city);
    updateProductRegion(city);
    updateFooterRegion(city);
    heroHeadingFromSavedZip(city, 0);
  };

  /* Legacy slideshow heading («PASADENA FLORIST») from the saved ZIP. The ZIP tables are only
     fetched when such a slideshow is on the page, so regular pages never load them for this. */
  function heroHeadingFromSavedZip(city, delay) {
    var zip = localStorage.getItem('pc_selected_zip') || '';
    if (!zip || !document.querySelector('.region-slideshow')) return;
    ensureData(function () {
      var zipCity = getCityByZip(zip);
      if (zipCity === city) {
        if (delay) setTimeout(function () { updateHeroHeading(zip); }, delay);
        else updateHeroHeading(zip);
      } else {
        localStorage.removeItem('pc_selected_zip');
      }
    });
  }



  function updateFooterRegion(city) {
    var names = { la: 'Los Angeles', sf: 'San Francisco', hnl: 'Honolulu', vc: 'Ventura County' };
    var delivHref = { la: '/pages/flower-delivery-la', sf: '/pages/san-francisco', hnl: '/collections/main-collection-hnl', vc: '/collections/all-flowers' };
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    var name = names[suffix];
    var links = document.querySelectorAll('.footer a');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.hasAttribute('data-pc-orig')) {
        if (a.textContent.indexOf('Los Angeles') === -1) continue;
        a.setAttribute('data-pc-orig', a.textContent);
        a.setAttribute('data-pc-orig-href', a.getAttribute('href') || '');
      }
      var orig = a.getAttribute('data-pc-orig');
      a.textContent = orig.replace(/Los Angeles/g, name);
      if (orig.indexOf('Flower Delivery') !== -1) {
        a.setAttribute('href', delivHref[suffix] || a.getAttribute('data-pc-orig-href'));
      }
    }
  }
  window.updateFooterRegion = updateFooterRegion;

  function updateCollectionRegion(city) {
    // Region from collection URL (collection's own region); else visitor city
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    var pcm = window.location.pathname.match(/\/collections\/[^\/]*-(vc|hnl|sf)(?:\/|$)/);
    if (pcm) suffix = pcm[1];
    if (suffix === 'la') return; // LA: nothing to localize
    var names = { sf: 'San Francisco', hnl: 'Honolulu', vc: 'Ventura County' };
    var across = { sf: 'the Bay Area', hnl: 'Oahu', vc: 'Ventura County' };
    var name = names[suffix], acr = across[suffix];
    // Replace via TEXT NODES only (nodeValue change = no childList mutation -> no observer loop -> grid stays intact)
    function swapText(root) {
      if (!root || root.getAttribute('data-pc-localized')) return;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue;
        if (v.indexOf('Los Angeles') !== -1 || v.indexOf('LOS ANGELES') !== -1 || /across LA\b/.test(v)) {
          n.nodeValue = v.replace(/LOS ANGELES/g, name.toUpperCase()).replace(/Los Angeles/g, name).replace(/across LA\b/g, 'across ' + acr);
        }
      }
      root.setAttribute('data-pc-localized', '1');
    }
    swapText(document.querySelector('[id$="__image_with_text_TdnByX"]'));
    swapText(document.querySelector('[id$="__rich_text_QKwxPW"]'));
  }
  window.updateCollectionRegion = updateCollectionRegion;

  /** Localize product description for regions sharing the LA catalog (2026-07-06) */
  function updateProductRegion(city) {
    if (!/^\/products\//.test(window.location.pathname)) return;
    var suffix = null;
    if (city === 'orange_county' || city === 'oc') suffix = 'oc';
    else if (city === 'inland_empire' || city === 'ie') suffix = 'ie';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    if (!suffix) return;
    var names = { oc: 'Orange County', ie: 'Inland Empire', vc: 'Ventura County' };
    var cityLists = {
      oc: 'Irvine, Anaheim, Santa Ana, Newport Beach, Costa Mesa, Huntington Beach, Tustin, Fullerton, Orange, Mission Viejo, Laguna Beach',
      ie: 'Ontario, Rancho Cucamonga, Chino, Chino Hills, Pomona, Upland, Fontana, Riverside, Corona, Eastvale, San Bernardino',
      vc: 'Ventura, Oxnard, Thousand Oaks, Camarillo, Simi Valley, Moorpark, Newbury Park, Ojai, Calabasas, Malibu, Hidden Hills'
    };
    var LA_LIST = 'Downtown LA, Beverly Hills, Santa Monica, Hollywood, Pasadena, Glendale, Burbank, Long Beach, Culver City, Sherman Oaks, Manhattan Beach';
    var name = names[suffix], list = cityLists[suffix], phone = CITY_PHONES[suffix] || CITY_PHONES.la;
    var root = document.querySelector('.product__description');
    if (!root || root.getAttribute('data-pc-region-localized')) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (v.indexOf(LA_LIST) !== -1) v = v.split(LA_LIST).join(list);
      if (v.indexOf('Los Angeles') !== -1) v = v.split('Los Angeles').join(name);
      if (v.indexOf('LOS ANGELES') !== -1) v = v.split('LOS ANGELES').join(name.toUpperCase());
      if (v.indexOf('(424) 303-2205') !== -1) v = v.split('(424) 303-2205').join(phone);
      if (v !== n.nodeValue) n.nodeValue = v;
    }
    var tels = root.querySelectorAll('a[href*="tel:"]');
    for (var t = 0; t < tels.length; t++) {
      if ((tels[t].getAttribute('href') || '').indexOf('4243032205') !== -1) {
        tels[t].setAttribute('href', 'tel:1' + phone.replace(/\D/g, ''));
      }
    }
    root.setAttribute('data-pc-region-localized', suffix);
  }
  window.updateProductRegion = updateProductRegion;


  function showCityTextSections(city) {
    var suffix = 'la';
    if (city === 'san_francisco' || city === 'sf') suffix = 'sf';
    else if (city === 'honolulu' || city === 'hnl') suffix = 'hnl';
    else if (city === 'ventura' || city === 'vc') suffix = 'vc';
    else if (city === 'orange_county' || city === 'oc') suffix = 'oc';
    else if (city === 'inland_empire' || city === 'ie') suffix = 'ie';

    var pairs = [
      ['__image_with_content_XfFXaY', 'la'],
      ['__image_with_content_XfFXaY_SF', 'sf'],
      ['__image_with_content_XfFXaY_HNL', 'hnl'],
      ['__image_with_content_XfFXaY_VC', 'vc'],
      ['__image_with_content_XfFXaY_OC', 'oc'],
      ['__image_with_content_XfFXaY_IE', 'ie']
    ];
    for (var i = 0; i < pairs.length; i++) {
      var el = document.querySelector('[id$="' + pairs[i][0] + '"]');
      if (el) el.style.display = (pairs[i][1] === suffix) ? '' : 'none';
    }

    // Region-variant content INSIDE a section via inner [data-pc-region] blocks (HNL -> LA fallback)
    var innerSections = ['__home_locations_div', '__home_faq_brand_v2'];
    var want = (suffix === 'sf' || suffix === 'vc' || suffix === 'hnl' || suffix === 'oc' || suffix === 'ie') ? suffix : 'la';
    for (var s = 0; s < innerSections.length; s++) {
      var sec = document.querySelector('[id$="' + innerSections[s] + '"]');
      if (!sec) continue;
      var regs = sec.querySelectorAll('[data-pc-region]');
      if (!regs.length) continue;
      var has = false;
      for (var q = 0; q < regs.length; q++) { if (regs[q].getAttribute('data-pc-region') === want) { has = true; break; } }
      var show = has ? want : 'la';
      for (var r = 0; r < regs.length; r++) {
        regs[r].style.display = (regs[r].getAttribute('data-pc-region') === show) ? '' : 'none';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    var city = getCookie(COOKIE_NAME) || getCityFromUrl() || (window.__STORE_CITY_FROM_CART__) || null;
    if (city) {
      showCityTextSections(city);
      updateAnnouncementPhone(city);
      updateCollectionRegion(city);
      updateProductRegion(city);
      updateFooterRegion(city);
    } else {
      showCityTextSections('los_angeles');
      updateAnnouncementPhone('los_angeles');
      updateCollectionRegion('los_angeles');
      updateFooterRegion('los_angeles');
    }
    heroHeadingFromSavedZip(city || 'los_angeles', 600);
  });

  // AIris blog 'Shop the story' block hooks into the same region pipeline (2026-09-02)
  window.pcRegion = { apply: applyRegion, region: cityToRegion };
  window.updateHeroHeading = updateHeroHeading;
  window.getLocalName = getLocalName;
  window.showCityTextSections = showCityTextSections;

})();
